import { useIsMobile } from "@/hooks";
import { useRecoilValue } from 'recoil'
import { Swiper, SwiperSlide } from 'swiper/react';
import { configColor, getPathByLink } from "@/utils";
import { HideCrumbsAtom } from "@/atoms";
import { useTranslation } from "react-i18next";
import { IModuleCarouselApiResponse } from "@/interfaces/IModuleDTO";
import SwiperCore, { Autoplay, Pagination } from 'swiper';

import styles from './Slider.module.css';
import Button from "../Button/Button";
import DOMPurify from 'isomorphic-dompurify';
import SearchPanel from "../SearchPanel/SearchPanel";
import 'swiper/css';
import "swiper/css/pagination";
import Image from "next/image";

SwiperCore.use([Autoplay]);

interface SliderProps {
  data: IModuleCarouselApiResponse,
  language: string
}

const paginationConfig = {
  clickable: true,
  renderBullet: (_: number, className: string) => {
    return '<div class="' + className + ' customBullet"></div>';
  },
};

const carouselAutoplayTime = process.env.NEXT_PUBLIC_CAROUSEL_AUTOPLAY_MILLISECONDS && !isNaN(Number(process.env.NEXT_PUBLIC_CAROUSEL_AUTOPLAY_MILLISECONDS)) ? Number(process.env.NEXT_PUBLIC_CAROUSEL_AUTOPLAY_MILLISECONDS) : 3000;

const Slider: React.FC<SliderProps> = ({ data, language }: SliderProps) => {

  const moduleData = data;
  

  const { i18n } = useTranslation();
  const lang = language || i18n.language;
  const [isMobile] = useIsMobile();
  const isHideCrumbs = useRecoilValue(HideCrumbsAtom);

  return (
    <div className={"w-full mb-10 " + styles.carouselSectionWrapper + ' ' + ((moduleData?.data && moduleData.data.xconM02) && moduleData?.data?.enuTypeInfo === 'visore con M02-Widget-lancio in overlay' ? 'higherPagination' : 'lowerPagination')}>
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        className="custom-carousel"
        loop={true}
        pagination={paginationConfig}
        autoplay={{ 
          delay: carouselAutoplayTime,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }}
        modules={[Pagination, Autoplay]}
      >
        {moduleData?.data?.lstViewer?.map(sliderItem => {
          const { mediaserverpath, resourcename } = isMobile ? sliderItem.upiImageMobile[lang] : sliderItem.upiImageDesktop[lang];
          const imagePath = mediaserverpath + '/' + resourcename;

          
          const titleText = sliderItem.lblTitle?.[lang]?.toLowerCase() || '';
          const subtitleText = sliderItem.lblSubtitle?.[lang]?.toLowerCase() || '';
          
          const isFairPlayBanner = titleText.includes('fair') || 
                                   titleText.includes('play') ||
                                   subtitleText.includes('gioca') || 
                                   subtitleText.includes('pulito') ||
                                   subtitleText.includes('vola') ||
                                   subtitleText.includes('sereno');
          
          console.log('Is Fair Play banner:', isFairPlayBanner);
          
          const slideHeight = isMobile ? "h-[500px]" : "h-[400px]";

          return <SwiperSlide key={sliderItem.id}>
            <div className={`${styles.slideItem} relative w-full ${slideHeight} overflow-hidden bg-gray-100`}>
              <Image
                alt=""
                aria-hidden="true"
                src={imagePath}
                fill
                className="absolute inset-0 z-0 object-cover"
                unoptimized
              />
              
              <div className={`absolute inset-0 z-1 ${isFairPlayBanner ? 'bg-black bg-opacity-0' : 'bg-black bg-opacity-5'}`}></div>
              
              <div className={`absolute inset-0 flex flex-col z-10 ${
                isMobile 
                  ? 'justify-start pt-12' 
                  : 'justify-start pt-16'
              }`}>
                <div className='max-w-cont-1 mx-auto px-4 sm:px-6 w-full'>
                  <div className="space-y-2 sm:space-y-4">
                    {sliderItem.lblTitle?.[lang] ? 
                      <h1 className={`${styles.slideTitle} ${configColor('text', sliderItem.enuTitleColor)} font-secondary`} 
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sliderItem.lblTitle[lang]) }}>
                      </h1> : null}
                    
                    {sliderItem.lblSubtitle?.[lang] ? 
                      <h2 className={`${styles.slideSubtitle} ${configColor('text', sliderItem.enuTitleColor)}`}
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sliderItem.lblSubtitle[lang]) }}>
                      </h2> : null}
                  </div>

                  {sliderItem.lblLabelCta?.[lang] ?
                    <div className="mt-4 sm:mt-6 mb-8 sm:mb-12">
                      <a href={getPathByLink(sliderItem,lang)} target={sliderItem.flgTarget ? "_blank" : "_self"}>
                        <Button className="active:bg-lightblue" text={sliderItem.lblLabelCta[lang]} />
                      </a>
                    </div> : null
                  }
                </div>
              </div>
            </div>
          </SwiperSlide>
        }) || []}
      </Swiper>
      
      {
        (moduleData?.data && moduleData.data.xconM02) && moduleData?.data?.enuTypeInfo === 'visore con M02-Widget-lancio in overlay' ?
          <div className='w-full relative max-w-cont-2 mx-auto 
                         -mt-[60px] sm:-mt-[80px] md:-mt-[90px] 
                         px-4 sm:px-6 z-20'>
            <SearchPanel language={lang} targetUrl={moduleData?.data.xconM02.targeturl} data={null}  />
          </div>
          : null
      }
    </div>
  )
}

export default Slider;